import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
/* empty css                 */
const StoreBrands = ({ className, labels, brands, ...rest }) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("store-brands-stores-v2", className) }, /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h3" }, labels.title), /* @__PURE__ */ React.createElement("ul", { className: "store-brands-stores-v2__list" }, brands.map(({ name }) => /* @__PURE__ */ React.createElement("li", { key: name, className: "store-brands-stores-v2__list-item" }, name))));
export {
  StoreBrands as default
};
//# sourceMappingURL=StoreBrands.js.map
